import { Component } from '@angular/core';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import { DocumentClient} from '../../../api/api-client';
import {DeleteDocumentRoutingInfo} from '../../../models/delete-document-routing-info';
import {TranslationPipe} from '../../../pipes/translation.pipe';
import {Button} from 'primeng/button';
import {SubscriptionManager} from '../../../services/subscription-manager.service';

@Component({
  selector: 'app-delete-document-dialog',
  imports: [
    TranslationPipe,
    Button
  ],
  providers: [SubscriptionManager],
  templateUrl: './delete-document-dialog.component.html',
  styleUrl: './delete-document-dialog.component.scss',
})
export class DeleteDocumentDialogComponent {

  routingData!: DeleteDocumentRoutingInfo;

  constructor(
    private readonly subscriptionManager:SubscriptionManager,
    public ref: DynamicDialogRef,
    private readonly dialogService: DialogService,
    private readonly documentClient:DocumentClient
  ) {
    this.routingData = <DeleteDocumentRoutingInfo>this.dialogService.getInstance(this.ref)?.data;
  }

  protected deleteDocument() {
    this.subscriptionManager.call(
    this.documentClient.deleteDocument(this.routingData.entityId),
      (x=>{
      if(x.status==200){
        this.ref.close(true);
      }
    })
    );
  }

  protected abort() {
    this.ref.close(false);
  }
}
